function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  fillRule: "evenodd",
  d: "M16.799 8.922l-2.726-2.753c-.27-.273-.71-.275-.984-.004-.273.27-.275.71-.005.983L14.64 8.72l-8.441.02c-.384.001-.695.313-.694.697 0 .384.312.694.696.694h.001l8.43-.02-1.548 1.564c-.27.273-.268.714.005.984.136.135.313.201.49.201.179 0 .358-.068.494-.206l2.726-2.752c.268-.271.268-.708 0-.98m-5.364 3.072v3.18c0 .385-.28.697-.664.697H1.696c-.385 0-.696-.312-.696-.696V3.696C1 3.31 1.311 3 1.696 3h9.075c.384 0 .664.311.664.696v3.181c0 .384-.312.696-.696.696-.384 0-.696-.312-.696-.696V4.391H2.391v10.087h7.652v-2.485c0-.385.312-.696.696-.696.384 0 .696.311.696.696"
});

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.414477b4.svg";
export { ForwardRef as ReactComponent };